module.exports = {
  HBL: 'Номер импортной накладной',
  SONO: 'SONO (сокращение без перевода)',
  UserDefinedField1: 'Пользовательское поле 1',
  UserDefinedField2: 'Пользовательское поле 2',
  UserDefinedField3: 'Пользовательское поле 3',
  UserDefinedField4: 'Пользовательское поле 4',
  accordingToBusiness: 'По виду операции',
  accordingToCharge: 'По расходам',
  accountStatementNo: 'Номер сверки',
  accrued: 'Начислено',
  addCharge: 'Добавить расходы',
  adjustedOrNot: 'Корректировка',
  advanceMoneyOrNot: 'Авансирование',
  airExport: 'Авиаэкспорт',
  airImport: 'Авиаимпорт',
  all: 'Все',
  amount: 'Сумма',
  amountNotWrittenOff: 'Непогашенная сумма',
  amountRange: 'Диапазон суммы',
  applicant: 'Заявитель',
  applicationNo: 'Номер заявки',
  applicationStatus: 'Статус заявки',
  appliedForPaymentOrNot: 'Подана ли заявка на оплату',
  approval: 'Утверждено',
  auditor: 'Проверяющий',
  awaitBusinessApproval: 'Ожидает проверки отдела',
  awaitFinancialApproval: 'Ожидает финансовой проверки',
  NosubmitWeaver: 'Ожидает отправки в облако',
  WeaverApproving: 'На проверке в облаке',
  WeaverApproved: 'Утверждено облаком',
  back: 'Назад',
  bankAccount: 'Банковский счет',
  bankOfDeposit: 'Банк',
  billNo: 'Номер счета',
  billPaymentNo: 'Номер заявки на оплату',
  bookingNo: 'Номер бронирования',
  businessApproval: 'Проверка отдела',
  officeApproval: 'Коммерческая проверка',
  businessCreateDate: 'Дата создания операции',
  businessDate: 'Дата операции',
  businessNumber: 'Номер операции',
  businessReferenceNumber: 'Референс операции',
  businessStatus: 'Статус операции',
  businessType: 'Тип операции',
  bySettlementAgent: 'Через расчетного агента',
  cancel: 'Отмена',
  cancelPartialWriteOff: 'Частичная отмена погашения',
  carrier: 'Перевозчик',
  carrierId: 'Перевозчик',
  chargeItem: 'Наименование расхода',
  chargeOriginalAmount: 'Первоначальная сумма расходов',
  chargeOriginalCurrency: 'Первоначальная валюта расходов',
  chargeOriginalExchangeRate: 'Первоначальный курс расходов',
  chargeRemark: 'Примечание к расходам',
  collectInvoice: 'Получение счета',
  confirmDate: 'Дата подтверждения',
  confirmRemarks: 'Примечание к подтверждению',
  confirmUser: 'Подтверждающее лицо расходов',
  confirmationStatus: 'Статус подтверждения',
  consignationCompany: 'Заказчик',
  contactPerson: 'Контактное лицо',
  containerNo: 'Номер контейнера',
  containerSizeAmount: 'Тип/количество контейнеров',
  controlledOrNot: 'Контролируется ли',
  couldNotSearhWriteOffJobFromThisWindow: 'Примечание: на этом интерфейсе отфильтрованы полностью списанные расходы/операции',
  creator: 'Создатель',
  currency: 'Валюта',
  customJobType: 'Пользовательский тип операции',
  customer: 'Клиент',
  customerContact: 'Контактное лицо по операции',
  customerService: 'Служба поддержки',
  dateOfApplication: 'Дата заявки',
  dateOfCreation: 'Дата создания',
  delete: 'Удалить',
  department: 'Отдел',
  departmentApproval: 'Согласование отдела',
  destinationAgent: 'Агент порта назначения',
  domesticInternational: 'Внутренний/международный',
  edit: 'Изменить',
  edit2: 'Редактировать',
  eta: 'ETA (предполагаемое время прибытия)',
  etd: 'ETD (предполагаемое время отправления)',
  atd: 'ATD (фактическое время отправления)',
  ata: 'ATA (фактическое время прибытия)',
  exchangeRate: 'Курс обмена',
  export: 'Экспорт',
  exportExcel: 'Экспорт в Excel',
  exportPDF: 'Экспорт в PDF',
  feeStatus: 'Статус расходов',
  financialApproval: 'Финансовое согласование',
  financialAudit: 'Финансовая проверка',
  financialDate: 'Финансовая дата',
  generatedBillsOrNot: 'Счет сгенерирован',
  import: 'Импорт',
  importhbl: 'Номер импортной накладной',
  includeReceivables: 'Включая дебиторскую задолженность',
  inputBy: 'Создатель расходов',
  inquiryWay: 'Способ запроса',
  invalid: 'Аннулировать',
  invoiceDate: 'Дата выставления счета',
  invoiceDateAll: 'Дата выставления счета',
  invoiceHeader: 'Наименование в счете',
  sellerInvoiceTitle: 'Seller invoice title',
  dateModified: 'Время изменения',
  modifiedBy: 'Изменивший',
  invoiceNo: 'Номер счета',
  invoiceState: 'Статус выставления счета к получению',
  invoicedOrNot: 'Счет выставлен?',
  invoicingMethod: 'Способ выставления счета',
  isNeedInvoice: 'Требуется ли выставить счет?',
  isReceivable: 'Тип дохода/расхода',
  itemNo: 'Номер проекта',
  lclMasterOrNot: 'Это малый счет?',
  masterFlagOrNot: 'Это основной счет?',
  mbl: 'Номер основного счета',
  methodOfPayment: 'Способ оплаты',
  monetaryEquivalent: 'Конвертированная сумма',
  needInvoice: 'Требуется ли выставить счет?',
  new: 'Добавить',
  newActualPayment: 'Добавить фактический платеж',
  newActualReceipt: 'Добавить фактическое поступление',
  newPaymentRequest: 'Создать заявку на оплату',
  changePaymentRequest: 'Изменить заявку на оплату',
  deletePaymentRequest: 'Удалить заявку',
  submintPaymentRequest: 'Отправить заявку',
  next: 'Далее',
  notSubmitted: 'Не отправлено',
  oceanExport: 'Морской экспорт',
  oceanImport: 'Морской импорт',
  operation: 'Действие',
  originalAmount: 'Исходная сумма',
  payReceiveDate: 'Дата поступления/оплаты',
  payables: 'К оплате',
  payment: 'Оплата',
  paymentDate: 'Дата оплаты',
  paymentPeriod: 'Срок оплаты',
  paymentPeriodUnit: 'Единица срока оплаты',
  paymentType: 'Тип платежа',
  planner: 'Ответственный за маршрут',
  portOfDestination: 'Порт назначения',
  portOfDestinationAirport: 'Порт назначения (аэропорт)',
  portOfDestinationSeaport: 'Порт назначения (морской порт)',
  portOfDischargeAirport: 'Порт разгрузки (аэропорт)',
  portOfDischargeSeaport: 'Порт разгрузки (морской порт)',
  portOfLoading: 'Порт отправления',
  portOfLoadingAirport: 'Порт отправления (аэропорт)',
  portOfLoadingSeaport: 'Порт отправления (морской порт)',
  portOfTransfer: 'Транзитный порт',
  print: 'Печать',
  quantity: 'Количество',
  query: 'Поиск',
  receipt: 'Получение платежа',
  receiptDate: 'Дата получения платежа',
  receivables: 'Дебиторская задолженность',
  receivablesWriteOfStatus: 'Статус списания дебиторской задолженности',
  relatedJob: 'Корреспондентский номер',
  remarks: 'Примечание',
  purpose: 'Назначение',
  postscript: 'Комментарий к транзакции',
  preRemarks: 'Примечание к предоплате',
  ticketNo: 'Номер документа',
  workflowNo: 'Номер процесса',
  removeCharge: 'Удалить расходы',
  return: 'Возврат',
  sales: 'Продажа',
  save: 'Сохранить',
  saveAndAdd: 'Сохранить и добавить',
  separateNumber: 'Номер разделенного счета',
  settleAccountsTo: 'Объект расчета',
  settlementAgent: 'Расчетный агент',
  settlementCompany: 'Расчетная единица',
  settlementType: 'Тип расчета',
  solicitationType: 'Тип грузоперевозки',
  status: 'Статус',
  submit: 'Отправить',
  taxAmount: 'Сумма налога',
  taxExcludedPrice: 'Цена без налога',
  taxIncludedPrice: 'Цена с налогом',
  taxRate: 'Налоговая ставка',
  theAmountOfWriteOffs: 'Сумма списания',
  currencyAmountOfWriteOffs: 'Итог списания по валютам',
  total: 'Итого',
  totalCurrency: 'Итого по валютам',
  totalWriteOffs: 'Общий итог списания',
  trustFromJob: 'Корреспондентский номер поручения',
  uncheck: 'Снять выделение',
  unit: 'Единица',
  unitPrice: 'Цена за единицу',
  unpaid: 'Не оплачено',
  vessel: 'Название судна',
  vesselAndVoyage: 'Название судна и рейс',
  viewDetails: 'Просмотр деталей',
  viewWriteOffList: 'Просмотр деталей списания',
  voyage: 'Рейс',
  warehouseNo: 'Номер поступления на склад',
  writeOffCurrency: 'Валюта списания',
  writeOffDate: 'Дата списания',
  writeOffExchangeRate: 'Курс списания',
  writeOffList: 'Детали списания',
  writeOffSerialNumber: 'Серийный номер списания',
  wroteOffOrNot: 'Списано ли',
  approveHistoryNode: 'Узел утверждения',
  invoice_voucherDate: 'Дата документа 2',
  time: 'Время',
  approveTime: 'Время утверждения',
  operator: 'Оператор',
  approval_results: 'Результат утверждения',
  applicationDepartment: 'Запрашивающий отдел',
  settleDepartmentPrefix: 'Расчетный отдел',
  writeOffStatus: 'Статус списания',
  moneyWriteOffStatus: 'Статус списания расходов',
  sendWeaver: 'Отправить в облачную платформу',
  receivablesAndPayables: 'Дебиторская и кредиторская задолженность',
  operationDate: 'Дата операции',
  newPaymentRequest_SR: 'Создать заявку на оплату',
  deletePaymentRequest_SR: 'Удалить заявку',
  sendWeaver_SR: 'Отправить в облачную платформу',
  viewDetails_SR: 'Просмотреть',
  lastInvoicingDate: 'Крайний срок выставления счета',
  paymentRequestState: 'Статус заявки на оплату',
  Cargo_ApplicantPassTips: 'Согласны ли вы с данной заявкой на оплату?',
  Cargo_ApplicantReturnToSubmitterTips: 'Эта заявка будет возвращена подавшему. Подтверждаете возврат?',
  Cargo_ApplicantReturnToBusinessTips: 'Эта заявка будет возвращена бизнес-аудитору. Подтверждаете возврат?',
  Cargo_ApplicantReturnToFinancialTips: 'Эта заявка будет возвращена финансовому аудитору. Подтверждаете возврат?',
  approveReason: 'Введите причину согласия',
  returnReason: 'Введите причину возврата',
  bdApproveState: 'Статус бизнес-утверждения',
  ccApproveState: 'Статус финансового утверждения',
  finApproveState: 'Финальный статус утверждения',
  receiptPaymentNo: 'Номер платежного документа'
}
